<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <input
          ref="input-select-product"
          type="text"
          class="form-control"
          placeholder="PESQUISAR POR NOME"
          @input="handleComponentFilterProducts"
          v-model="searchComponentFilterProducts"
        />
      </div>
      <div class="col-md-12">
        <b-overlay :show="loadingComponentFilterProducts" opacity="0.99">
          <v-data-table
            dense
            :headers="[{ sortable: false, value: 'item' }]"
            item-key="`${type}`/${id}"
            :items="componentFilterProducts"
            :footer-props="{
              'items-per-page-options': [35],
              'items-per-page-text': 'Mostrar',
            }"
            no-data-text="SEM RESULTADOS"
            :options.sync="optionsComponentFilterProducts"
            :server-items-length="totalComponentFilterProducts"
            @click:row="handleClickRowTableComponentFilterProducts"
            class="SelectProductID-table"
          >
            <template v-slot:[`item.item`]="{ item }">
              <div class="pt-1 pb-1">
                <h6 class="mb-0">
                  NOME:
                  {{ item.name }}
                </h6>
                <div class="mb-0">
                  UNIDADE DE MEDIDA:
                  {{ item.unit_of_measurement_name }}
                </div>
              </div>
            </template>
          </v-data-table>
        </b-overlay>
      </div>
      <div
        v-if="productComponentFilterProducts.id && showProduct"
        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
      >
        <strong>
          <span class="text-muted">NOME:</span>
          {{ productComponentFilterProducts.name }}
        </strong>
        <br />
        <small>
          <strong>
            <span class="text-muted">UNIDADE DE MEDIDA:</span>
            {{ productComponentFilterProducts.unit_of_measurement_name }}
          </strong>
        </small>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../services/api";

import permission from "../../lib/permission";

export default {
  name: "SelectProductID",
  props: {
    showProduct: Boolean,
    newProduct: { type: Boolean, default: true },
  },
  data() {
    return {
      totalComponentFilterProducts: 0,
      optionsComponentFilterProducts: {
        page: 1,
        itemsPerPage: 35,
      },
      productComponentFilterProducts: {},
      componentFilterProducts: [],
      searchComponentFilterProducts: "",
      loadingComponentFilterProducts: false,
    };
  },
  watch: {
    optionsComponentFilterProducts: {
      handler() {
        this.handleComponentFilterProducts();
      },
    },
  },
  created() {
    setTimeout(() => this.$refs["input-select-product"].focus(), 200);
  },
  methods: {
    permission,
    handleClickRowTableComponentFilterProducts(product) {
      this.productComponentFilterProducts = product;
      this.$emit("selected", product);
    },
    handleClickCreateProduct() {
      const { searchComponentFilterProducts: product } = this;
      this.productComponentFilterProducts = product;
      this.$emit("selected", product);
    },
    async handleComponentFilterProducts() {
      try {
        this.loadingComponentFilterProducts = true;

        const { page, itemsPerPage } = this.optionsComponentFilterProducts;

        const { searchComponentFilterProducts } = this;

        let params = {
          filter: searchComponentFilterProducts,
          page,
          itemsPerPage,
        };

        const response = await api.get("/rest-home/product/filter", {
          params,
        });

        const { error, errors, products, total } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.componentFilterProducts = products;
          this.totalComponentFilterProducts = total;

          this.loadingComponentFilterProducts = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>


<style>
.SelectProductID-table {
  max-height: 300px !important;
  overflow: scroll;
}
</style>